import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskRequirementSelfScheduleUpdated_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from '../../Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskRequirementSelfScheduleUpdated_ActivityLogFragment;
}

const ActivityLogTaskRequirementSelfScheduleUpdated: FCWithFragments<Fragments> = ({ activityLog }) => {
  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.updatedSelfScheduleRequest"
    />
  );
};

ActivityLogTaskRequirementSelfScheduleUpdated.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskRequirementSelfScheduleUpdated_activityLog on ActivityLog {
      id

      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskRequirementSelfScheduleUpdated;
